module.exports = __webpack_public_path__ + "static/media/Shop Ezpop.9af17b3c.png";